import React, { useEffect, useState } from 'react';
import { CircularProgress, Switch } from '@mui/material';
import { SetWifiCredentialsProps } from './setWifiCredentialsProps';
import { useDeviceSetWifiCredentialsMutation } from '../../../../services/device/deviceService';
import { SelectItemMethod } from '../../../../components/commons/SideBarComponents/SelectItemMethod/selectItemMethod';
import {
  ButtonStyled,
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import Strings from '../../../../i18n';
import { SideBarEditablePropertyItem } from '../../../../components/commons/SideBarComponents/EditablePropertyItem/sideBarEditablePropertyItem';
import { useGetAccessPointsByLocationMutation } from '../../../../services/locations/locationsService';
import { LoadingRowsComponent } from '../../../../components/commons/LoadingRows/LoadingRows';
import { SideBarSwitchWithLabel } from '../../../../components/commons/SideBarComponents/SwitchWithLabel/sideBarSwitchWithLabel';

export const SetWifiCredentialsComponent = ({
  deviceIds,
  locationIds,
  setOpenRightSideBar,
  clearSelectedDevices
}: SetWifiCredentialsProps) => {
  const [ssidName, setSsidName] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [connectedDevices, setConnectedDevices] = useState(0);
  const [selectedAccessPointId, setSelectedAccessPointId] = React.useState('');
  const [showAccessPoints, setShowAccessPoints] = React.useState(false);
  const [setWifiCredentials, { isSuccess, isLoading }] =
    useDeviceSetWifiCredentialsMutation();

  const [
    getAccessPointsByLocation,
    { isLoading: isLoadingGetAccessPointsByLocation, data: accessPoints }
  ] = useGetAccessPointsByLocationMutation();
  const sendWifiCredentials = () => {
    if (deviceIds.length > 0) {
      setWifiCredentials({
        deviceIds,
        ssid: ssidName,
        password
      });
    }
  };
  useEffect(() => {
    if (isSuccess) {
      setOpenRightSideBar(false);
      clearSelectedDevices();
    }
  }, [isSuccess]);

  useEffect(() => {
    if (
      showAccessPoints &&
      locationIds.every((locationId) => locationId === locationIds[0])
    ) {
      getAccessPointsByLocation(locationIds[0]);
    }
  }, [locationIds, showAccessPoints]);

  useEffect(() => {
    if (accessPoints) {
      const selected = accessPoints.find(
        (accessPoint) =>
          +accessPoint.locationAccessPointId === +selectedAccessPointId
      );
      if (selected) {
        setConnectedDevices(selected.controllerCount);
        setSsidName(selected.ssidName);
        setPassword(selected.ssidPassword);
      }
    }
  }, [selectedAccessPointId]);

  return (
    <>
      <StyledContainerItems>
        <StyledTitleSideBar>
          {Strings.serverAccess.devices.setWifiCredentialsLabel}
        </StyledTitleSideBar>
        <SideBarSwitchWithLabel
          label="Show Existing Access Points"
          checked={showAccessPoints}
          onChange={() => setShowAccessPoints(!showAccessPoints)}
        />
        {isLoadingGetAccessPointsByLocation && (
          <LoadingRowsComponent rows={2} />
        )}
        {showAccessPoints && accessPoints && (
          <SelectItemMethod
            item={{
              label: Strings.devices.currentAccessPointLabel,
              currentValue: selectedAccessPointId,
              placeholder: Strings.devices.ssidPlaceholder,
              options:
                accessPoints?.map((accessPoint) => ({
                  id: accessPoint.locationAccessPointId,
                  name: accessPoint.ssidName
                })) ?? [],
              onChange: (
                e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
              ) => {
                setSelectedAccessPointId(e.target.value);
              }
            }}
          />
        )}
        <SideBarEditablePropertyItem
          item={{
            label: Strings.devices.ssidLabel,
            type: 'inputText',
            currentValue: ssidName,
            placeholder: Strings.devices.ssidPlaceholder,
            onChange: (
              e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => setSsidName(e.target.value.toString())
          }}
        />
        <SideBarEditablePropertyItem
          item={{
            label: Strings.devices.passwordLabel,
            type: 'inputText',
            currentValue: password,
            placeholder: Strings.devices.passwordPlaceholder,
            onChange: (
              e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => setPassword(e.target.value.toString())
          }}
        />
        {showAccessPoints && accessPoints && (
          <SideBarEditablePropertyItem
            item={{
              label: Strings.devices.connectedDevices,
              type: 'inputText',
              currentValue: connectedDevices,
              disabled: true
            }}
          />
        )}
      </StyledContainerItems>
      <StyledContainerFooterSideBar>
        <button
          type="button"
          className="btn-cancel"
          onClick={() => {
            setOpenRightSideBar(false);
            clearSelectedDevices();
          }}
        >
          {Strings.common.cancel}
        </button>
        <button
          type="button"
          className="btn-save"
          disabled={ssidName === '' || password === ''}
          onClick={sendWifiCredentials}
        >
          {Strings.common.add}
        </button>
      </StyledContainerFooterSideBar>
    </>
  );
};
